<template>
<main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
  <!--=====================================
     Page Header Details Section
  ======================================-->
  <section class="pt-32 max-md:pb-20 md:py-44 lg:pt-[200px] relative overflow-hidden">
    <!-- Gradient Background Wrapper -->
    <div id="hero-gradient-wrapper" class="absolute w-full h-full top-0 left-0 -z-10 blur-[35px] md:blur-[60px] sm:scale-[0.1] bg-blend-multiply md:scale-75">
      <img src="images/hero-gradient-background.png" alt="hero-gradient-background" id="hero-gradient" class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-[45%]" />
    </div>

    <!-- Hero Content Container -->
    <div class="container reveal-me">
      <div class="text-center">
        <!-- Badge Component -->
        <div class="rv-badge mb-4 lg:mb-10">
          <span class="rv-badge-text">Services Details</span>
        </div>

        <!-- Hero Title -->
        <h1 class="mb-5 lg:mb-8">Marketing</h1>

        <!-- Hero Description -->
        <p class="max-md:max-w-[650px]">
          Drive growth and engagement with data-driven marketing strategies designed to make an impact. Our expertise includes:<br><br>
        </p>
      </div>
    </div>
  </section>

  <!--=====================================
     Services Details Section
  ======================================-->
  <section class="pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]">
    <div class="max-w-[1440px] mx-auto px-8 md:px-20">
      <div class="flex flex-col gap-8 lg:flex-row justify-start">
        <!-- Sticky Table of Contents -->
        <aside class="min-w-[275px] flex-1">
          <div class="sticky top-28">
            <div class="reveal-me">
              <h3 class="max-md:text-[40px] md:text-[32px]">Table of contents</h3>
              <ul class="mt-4 sm:mt-7 md:mt-10 [&>*:not(:last-child)]:mb-2 md:[&>*:not(:last-child)]:mb-5">
                <li>
                  <a href="#service-overview" class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">Service overview</a>
                </li>
                <li>
                  <a href="#our-service-includes" class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">Our service includes</a>
                </li>
                <li>
                  <a href="#why-choose" class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">Why Choose Us</a>
                </li>
              </ul>
            </div>
          </div>
        </aside>

        <!-- Main Content -->
        <article class="project-details-body">
          <div class="reveal-me">
            <h3 id="service-overview">Service overview</h3>
            <p>
              At Neue Media, we craft marketing strategies that drive measurable results. Our approach combines deep data analysis with creative insights to propel your brand forward.
            </p>
          </div>
          <div class="reveal-me">
            <h3 id="our-service-includes">Our service includes</h3>
            <p>
              In-Depth Market Research: We analyze your market and competitors to tailor strategies for optimal growth.<br><br>
              <strong>SEO & Content Strategy:</strong> Develop organic growth through keyword optimization and engaging blog content.<br><br>
              <strong>Paid Advertising:</strong> Execute high-impact campaigns across Google Ads and social platforms with conversion optimization.<br><br>
              <strong>Brand Growth:</strong> Enhance your brand’s online presence with comprehensive social media, email marketing, and influencer collaborations.
            </p>
          </div>
          <div class="reveal-me">
            <h3 id="why-choose">Why Choose Us</h3>
            <p>
              Expertise and Insight: Our team leverages extensive market data and creative strategy to drive growth.<br><br>
              Customized Solutions: We tailor our marketing approach to fit your unique brand needs.<br><br>
              Transparent Process: Enjoy clear communication and measurable results at every stage.<br><br>
              End-to-End Support: From strategy to execution, we manage all aspects of your marketing campaign.<br><br>
              Results-Driven: Our focus is on delivering growth and engagement that translates into real business success.
            </p>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!--=====================================
     CTA Section
  ======================================-->
  <section class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-[70px] lg:pb-[140px] relative">
    <div class="container">
      <!-- CTA Heading -->
      <h2 class="text-center xl:text-[96px] font-normal xl:leading-[1.1] xl:tracking-[-2.88px]">
        Got Questions?
        <span class="font-instrument sm:mt-10 italic block max-md:inline-block">
          We’ve Got Answers
        </span>
      </h2>

      <ul class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none">
        <!-- Primary CTA Button -->
        <li class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto"></li>
        <!-- Secondary CTA Button -->
        <li class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto">
          <router-link to="/contact" class="rv-button rv-button-primary block md:inline-block">
            <div class="rv-button-top contact-btn-lg">
              <span>Let's Connect</span>
            </div>
            <div class="rv-button-bottom contact-btn-lg">
              <span>Let's Connect</span>
            </div>
        </router-link>
        </li>
      </ul>
    </div>
  </section>

</main>

<!--=====================================
   Footer Section
======================================-->
<FooterComponent/>


</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue'
export default {
  name: 'MarketingPage',
  components: {
    FooterComponent,
  }
}
</script>